import { render } from "./IconBase.vue?vue&type=template&id=3c5ad45a&lang=pug&bindings={\"iconName\":\"props\",\"iconColor\":\"props\",\"viewBox\":\"props\"}"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"
script.render = render

export default script